// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".success-text[data-v-8fe1b4ea]{font-size:24px;opacity:1}.renewed-text[data-v-8fe1b4ea]{font-size:12px;opacity:.5}", ""]);
// Exports
module.exports = exports;
